import { TYPE_COLLECTION } from './input-types';

export const id = 'fulfillmentProvider';
export const apiKey = 'SellerFillProviderId';
export const type = TYPE_COLLECTION;

export const fulfillmentProvider = {
  id,
  apiKey,
  type,
};
